import { render, staticRenderFns } from "./cusParamDialog.vue?vue&type=template&id=2dca1674"
import script from "./cusParamDialog.vue?vue&type=script&lang=js"
export * from "./cusParamDialog.vue?vue&type=script&lang=js"
import style0 from "./cusParamDialog.vue?vue&type=style&index=0&id=2dca1674&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports